import type { RouteRecordRaw } from "vue-router";
import { FeatureFlagName } from "@/services/fyApi";
import { routes as membersRoutes } from "@/frontend/pages/fleets/[slug]/members/routes";
import { routes as squadronsRoutes } from "@/frontend/pages/fleets/[slug]/squadrons/routes";
import { routes as logisticsRoutes } from "@/frontend/pages/fleets/[slug]/logistics/routes";
import { routes as contractsRoutes } from "@/frontend/pages/fleets/[slug]/contracts/routes";
import { routes as missionsRoutes } from "@/frontend/pages/fleets/[slug]/missions/routes";
import { routes as eventsRoutes } from "@/frontend/pages/fleets/[slug]/events/routes";
import { routes as toursRoutes } from "@/frontend/pages/fleets/[slug]/tours/routes";
import { routes as settingsRoutes } from "@/frontend/pages/fleets/[slug]/settings/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "fleet",
    component: () => import("@/frontend/pages/fleets/[slug]/index.vue"),
    meta: {
      backgroundImage: "bg-8",
      customTitle: true,
    },
  },
  {
    path: "ships/",
    name: "fleet-ships",
    component: () => import("@/frontend/pages/fleets/[slug]/ships.vue"),
    meta: {
      backgroundImage: "bg-8",
      customTitle: true,
    },
  },
  {
    path: "blueprints/",
    name: "fleet-blueprints",
    component: () => import("@/frontend/pages/fleets/[slug]/blueprints.vue"),
    meta: {
      mobileBack: true,
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
  },
  {
    path: "fleetchart/",
    name: "fleet-fleetchart",
    redirect: {
      name: "fleet-ships",
      query: { fleetchart: "true" },
    },
  },
  {
    path: "members/",
    name: "fleet-members",
    component: () => import("@/frontend/pages/fleets/[slug]/members.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: membersRoutes[0].name,
    },
    children: membersRoutes,
  },
  {
    path: "squadrons/",
    name: "fleet-squadrons-root",
    component: () => import("@/frontend/pages/fleets/[slug]/squadrons.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: squadronsRoutes[0].name,
    },
    children: squadronsRoutes,
  },
  {
    path: "logistics/",
    name: "fleet-logistics-root",
    component: () => import("@/frontend/pages/fleets/[slug]/logistics.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: logisticsRoutes[0].name,
    },
    children: logisticsRoutes,
  },
  {
    path: "allies/:list(incoming|outgoing|ignored)?/",
    name: "fleet-allies",
    redirect: (to) => ({
      name: to.params.list
        ? `fleet-settings-allies-${String(to.params.list)}`
        : "fleet-settings-allies",
      params: { slug: to.params.slug },
    }),
  },
  {
    path: "contracts/",
    name: "fleet-contracts-root",
    component: () => import("@/frontend/pages/fleets/[slug]/contracts.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: contractsRoutes[0].name,
    },
    children: contractsRoutes,
  },
  {
    path: "missions/",
    name: "fleet-missions-root",
    component: () => import("@/frontend/pages/fleets/[slug]/missions.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: missionsRoutes[0].name,
    },
    children: missionsRoutes,
  },
  {
    path: "events/",
    name: "fleet-events-root",
    component: () => import("@/frontend/pages/fleets/[slug]/events.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
      feature: FeatureFlagName.FLEET_MISSION_BUILDER,
      featureScope: "fleet",
    },
    redirect: {
      name: eventsRoutes[0].name,
    },
    children: eventsRoutes,
  },
  {
    path: "tours/",
    name: "fleet-tours-root",
    component: () => import("@/frontend/pages/fleets/[slug]/tours.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      customTitle: true,
    },
    redirect: {
      name: toursRoutes[0].name,
    },
    children: toursRoutes,
  },
  {
    path: "calendar/",
    name: "fleet-calendar",
    redirect: (to) => ({
      name: "fleet-events",
      params: { slug: to.params.slug },
      query: { view: "calendar" },
    }),
  },
  {
    path: "settings/",
    name: "fleet-settings",
    component: () => import("@/frontend/pages/fleets/[slug]/settings.vue"),
    meta: {
      needsAuthentication: true,
      backgroundImage: "bg-8",
      title: "fleets.settings.index",
      customTitle: true,
    },
    redirect: {
      name: settingsRoutes[0].name,
    },
    children: settingsRoutes,
  },
  {
    path: "stats/",
    name: "fleet-stats",
    component: () => import("@/frontend/pages/fleets/[slug]/stats.vue"),
    meta: {
      backgroundImage: "bg-8",
      title: "fleets.stats",
      customTitle: true,
    },
  },
];
